// extracted by mini-css-extract-plugin
export default {"bottomMargin":"Portfolio_bottomMargin_Kz9Mv"};